import { BrowserModule } from '@angular/platform-browser';
import { LOCALE_ID, NgModule } from '@angular/core';
import { registerLocaleData } from '@angular/common';

// importar locales
import localeEsAr from '@angular/common/locales/es-AR';

// registrar los locales con el nombre que quieras utilizar a la hora de proveer
registerLocaleData(localeEsAr, 'es-Ar');

// Routes
import { APP_ROUTES } from './app.routes';

// Forms
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// Services
import { ServiceModule } from './services/service.module';

// Translation Modules
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './login/register.component';
import { NopagefoundComponent } from './shared/nopagefound/nopagefound.component';
import { PagesModule } from './pages/pages.module';
import { AsistenciaComponent } from './certificados/asistencia/asistencia.component';
import { TrabajoComponent } from './certificados/trabajo/trabajo.component';
import { CertificadoCursoComponent } from './certificados/certificado-curso/certificado-curso.component';
import { CertificadosSimposiosComponent } from './certificados/certificados-simposios/certificados-simposios.component';
import { CertificadoConferenciaComponent } from './certificados/certificado-conferencia/certificado-conferencia.component';
import { CertificadosTalleresComponent } from './certificados/certificados-talleres/certificados-talleres.component';
import { CertificadosMesasComponent } from './certificados/certificados-mesas/certificados-mesas.component';
import { RecuperarPasswordComponent } from './login/recuperar-password.component';
import { CertificadoPagoComponent } from './certificados/certificado-pago/certificado-pago.component';


@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    RegisterComponent,
    NopagefoundComponent,
    AsistenciaComponent,
    TrabajoComponent,
    CertificadoCursoComponent,
    CertificadosSimposiosComponent,
    CertificadoConferenciaComponent,
    CertificadosTalleresComponent,
    CertificadosMesasComponent,
    RecuperarPasswordComponent,
    CertificadoPagoComponent
  ],
  imports: [
    BrowserModule,
    APP_ROUTES,
    PagesModule,
    FormsModule,
    ReactiveFormsModule,
    ServiceModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'es-Ar' }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts